import TouchAnimation from "../animations/pin/TouchAnimation";
// const touchSoundUrl = require("../../../assets/audio/pinTouch.wav");
// const touchSoundUrl = require("../../../assets/audio/pinTouch2.wav");
// const touchSoundUrl = require("../../../assets/audio/pinTouch4.wav");
// const touchSound = new Audio(touchSoundUrl.default);
export default function finalTouch(
  startingXY,
  ctx,
  coef,
  anims,
  finalXY,
  final,
  touch,
  spin,
  handleCoordinates,
  handleTween,
  time,
  speed,
  rows
) {
  // Ball finalX coordinates
  const { x: startX, y: startY, r } = startingXY;
  const { x: finalX, y: finalY } = finalXY;

  final(finalX + touch.x1, finalY + touch.y1);

  const anim = new TouchAnimation(startX, startY, r, ctx, rows);
  // touchSound.currentTime = 0;
  // touchSound.play();
  setTimeout(() => {
    anims.push(anim);
  }, 75 / speed);
  setTimeout(() => {
    anims.shift();
  }, 175 / speed);

  handleCoordinates(spin);
  handleTween(time / speed);
}
